import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { useFormikContext } from 'formik'
import DateInput from '../../../components/Formik/Forms/DateInput'
import SelectInput from '../../../components/Formik/Forms/SelectInput'
import SwitchInput from '../../../components/SwitchInput'
import TextInput from '../../../components/Formik/Forms/TextInput'
import { CenarioMetadataResponse, TipoCenario } from '../types'

interface Props {
  metadata: CenarioMetadataResponse | null
  tipoDisabled: boolean
}

export function IdentificacaoVigencia({ metadata, tipoDisabled }: Props) {
  const { setFieldValue } = useFormikContext()

  const tipoOptions = metadata
    ? Object.entries(metadata.tipos).map(([tipo, m]) => ({
        value: tipo,
        label: m.label
      }))
    : []

  function handleChangeTipo(event: React.ChangeEvent<{ value: unknown }>) {
    const novoTipo = event.target.value as string
    setFieldValue('tipo', novoTipo)

    const chaves = metadata?.tipos[novoTipo as TipoCenario]?.chaves ?? []
    const valoresDefault = Object.fromEntries(
      chaves.map((chave: typeof chaves[number]) => [
        chave.chave,
        chave.dominio.tipo === 'booleano-sn' ? false : ''
      ])
    )
    setFieldValue('valores', valoresDefault)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5">Identificação e vigência</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <SelectInput
          name="tipo"
          label="Tipo de Cenário"
          options={tipoOptions}
          disabled={tipoDisabled}
          onChange={tipoDisabled ? undefined : handleChangeTipo}
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        <TextInput name="descricao" label="Descrição" uppercase={false} />
      </Grid>
      <Grid item xs={12} sm={3}>
        <DateInput name="dataInicio" label="Início da Vigência" />
      </Grid>
      <Grid item xs={12} sm={3}>
        <DateInput name="dataFim" label="Fim da Vigência" />
      </Grid>
      <Grid item xs={12} sm={3}>
        <SwitchInput name="ativo" label="Ativo" />
      </Grid>
    </Grid>
  )
}
